'use strict';

import { newModalFromString } from '../components/modal';

export const bonusProductModalListener = (e) => {
    $('body').on('click', '#checkout-button-secure-checkout', function (e) {
        e.preventDefault();
        const unavailableProducts = $('#removeUnavailableItemsModal').data('unavailable-skus');
        const hasUnavailableItems = unavailableProducts && unavailableProducts.length > 0;
        if (unavailableProducts && unavailableProducts.length > 0 && hasUnavailableItems) {
            removeAllUnavailableLineItems();
        } else if ($('.wrapper-bonus-product-button').length > 0) {
            openBonusModal(e);
        } else {
            window.location.href = $(e.currentTarget).data('url');
        }
    });
};

export const openBonusModal = e => {
    if ($('.modal-was-closed').val() === 'true') {
        window.location.href = $(e.currentTarget).data('url');
        return;
    }
    if ($('.tingle-modal.layer-bonus-modal').length > 0) {
        return;
    }
    const htmlContent = $('#pendingBonusModal').clone().html();
    const onClose = () => {
        $('.modal-was-closed').val('true');
    };
    var modal = newModalFromString(htmlContent, false, ['layer-bonus-modal'], null, onClose);
    modal.open();
    $(modal.modalBox).addClass('rightModalAttribute');
    if ($('.layer-minicart-modal').hasClass('tingle-modal--visible')) {
        $(modal.modalBox).addClass('minicart-style');
    }
    $(modal.modalBox)
        .find('.close-button-info')
        .on('click', function () {
            modal.close();
        });
    $(modal.modalBox)
        .find('.js-proceed-to-checkout')
        .on('click', function (e) {
            $('.modal-was-closed').val('true');
            modal.close();
            if ($('.modal-was-closed').hasClass('klarna')) {
                $('.js-ModalExpressButton-klarna').trigger('click');
            } else if ($('.modal-was-closed').hasClass('apple')) {
                $('.js-ModalExpressButton-applePay').trigger('click');
            } else if ($('.modal-was-closed').hasClass('amazon')) {
                $('.js-ModalExpressButton-amazonPay').trigger('click');
            } else if ($('.modal-was-closed').hasClass('paypal')) {
                $('.js-ModalExpressButton-paypal').trigger('click');
            } else {
                window.location.href = $(e.currentTarget).data('url');
            }
        });
    $(modal.modalBox)
        .find('.js-choose-gift-details')
        .on('click', function (e) {
            var uuid = $(e.currentTarget).data('uuid');
            modal.close();
            $('.bonus-product-button[data-duuid="' + uuid + '"]').trigger('click');
        });
};

export function removeAllUnavailableLineItems () {
    const modalElement = document.getElementById('removeUnavailableItemsModal');

    if (!modalElement) {
        return null;
    }

    const htmlContent = modalElement.innerHTML;

    const modal = newModalFromString(htmlContent, false, ['cc-removeAllUnavailableModal', 'cc-removeProductModal']);

    if (!modal || !modal.modalBox) {
        return null;
    }

    moveModalCloseButton();
    modal.open();

    const $modalElement = $(modalElement);
    const url = $modalElement.data('action');
    const unavailableProducts = $modalElement.data('unavailable-skus');

    if (!url || !unavailableProducts) {
        modal.close();
        return null;
    }

    $(modal.modalBox).on('click', '#remove-all-unavailable-items-confirm, [data-dismiss="modal"]', function (e) {
        e.preventDefault();
        removeUnavailableItems(modal, url, unavailableProducts);
        modal.close();
    });

    return modal;
};

const removeUnavailableItems = (modal, url, unavailableProducts) => {
    $.spinner().start();

    $.ajax({
        url: url,
        data: {
            unavailableProducts: JSON.stringify(unavailableProducts),
        },
        type: 'POST',
        success: function () {
            $.spinner().stop();
            location.reload();
        },
        error: function (data) {
            $.spinner().stop();
            $(modal.modalBoxContent).find('.modal-body')
                .hide()
                .html('<p>' + data.responseJSON.message + '</p>')
                .fadeIn();
        }
    });
};

const moveModalCloseButton = () => {
    var close = document.querySelector('.tingle-modal__close');
    var modalContent = document.querySelector('.tingle-modal-box__content');
    modalContent.appendChild(close);
};
